<template>
  <b-card>
    <!-- form -->
    <validation-observer ref="modelsUpdate">
      <b-form>
        <b-row>
          <b-col md="12">
            <div class="section-block mb-4">
              <div class="section-block__title">
                <feather-icon
                  icon="ListIcon"
                  width="24"
                  height="24"
                />
                <h2>Model specifications</h2>
              </div>
              <b-form-group
                label="Name"
                label-class="label-class"
              >
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  rules="required|max:255"
                >
                  <b-form-input
                    v-model="form.name"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Name"
                    autocomplete="off"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <div
                class="neighbouring-form-container"
              >
                <b-form-group
                  label="Type"
                  label-class="label-class"
                  class="neighbouring-form-group"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="type"
                    vid="type"
                  >
                    <v-select
                      v-model="form.type"
                      :options="typesList"
                      :reduce="type => type.id"
                      placeholder="Select type"
                      label="name"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  label="Manufacturer"
                  label-class="label-class"
                  class="neighbouring-form-group"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="manufacturer"
                    vid="manufacturer_id"
                  >
                    <v-select
                      v-model="form.manufacturer_id"
                      :options="manufacturersList"
                      :reduce="manufacturer => manufacturer.id"
                      placeholder="Select manufacturer"
                      label="name"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group
                  label="Manufacturer Name"
                  label-class="label-class"
                  class="neighbouring-form-group"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="manufacturer_name"
                    rules="required|max:255"
                  >
                    <b-form-input
                      v-model="form.manufacturer_name"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Manufacturer Name"
                      autocomplete="off"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </div>

              <div
                class="neighbouring-form-container"
              >
                <b-form-group
                  label="Product Code, SKU"
                  label-class="label-class"
                  class="neighbouring-form-group"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="sku"
                    rules="required|max:255"
                  >
                    <b-form-input
                      v-model="form.sku"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Product Code, SKU"
                      autocomplete="off"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  label="System Board Model"
                  label-class="label-class"
                  class="neighbouring-form-group"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="system_board_model"
                    rules="required|max:255"
                  >
                    <b-form-input
                      v-model="form.system_board_model"
                      :state="errors.length > 0 ? false:null"
                      placeholder="System Board Model"
                      autocomplete="off"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </div>

              <div
                v-if="form.type ? form.type.includes('controller') : false"
                class="neighbouring-form-container mt-1"
              >
                <b-form-group
                  label=""
                  label-class="label-class"
                  class="neighbouring-form-group input-with-checkbox switch-row"
                >
                  <p>Apply IP Firewall Bridge:</p>
                  <b-form-checkbox
                    v-model="form.is_use_ip_firewall"
                    class="mr-0"
                    switch
                    inline
                  />
                </b-form-group>
              </div>
              <div
                v-if="form.type ? form.type.includes('controller') : false"
                class="neighbouring-form-container mt-1"
              >
                <b-form-group
                  label=""
                  label-class="label-class"
                  class="neighbouring-form-group input-with-checkbox switch-row"
                >
                  <p>New CAPsMAN only:</p>
                  <b-form-checkbox
                    v-model="form.is_only_new_capsman"
                    class="mr-0"
                    switch
                    inline
                  />
                </b-form-group>
              </div>
            </div>
            <div class="section-block mb-4">
              <div class="section-block__title">
                <feather-icon
                  icon="GlobeIcon"
                  width="24"
                  height="24"
                />
                <h2>Ports</h2>
              </div>
              <!-- loop for ports -->
              <div
                v-for="(port, index) in form.ports"
                :key="index"
                class="neighbouring-form-container"
              >
                <b-form-group
                  label="Interface"
                  label-class="label-class"
                  class="neighbouring-form-group"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="interface"
                    rules="required|max:255"
                  >
                    <b-form-input
                      v-model="port.interface"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Interface"
                      autocomplete="off"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  label="Usage"
                  label-class="label-class"
                  class="neighbouring-form-group"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="usage"
                    rules="required|max:255"
                  >
                    <v-select
                      v-model="port.usage"
                      :options="portsTypes"
                      placeholder="Usage"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <div
                  class="neighbouring-form-group with-button"
                >
                  <b-form-group
                    label="Display Name:"
                    label-class="label-class"
                    class="neighbouring-form-group"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="label"
                      rules="max:7"
                    >
                      <b-form-input
                        v-model="port.label"
                        :state="errors.length > 0 ? false:null"
                        placeholder="Display Name"
                        autocomplete="off"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <button
                    type="button"
                    class="remove-button"
                    @click="form.ports.splice(index, 1)"
                  >
                    <feather-icon
                      icon="TrashIcon"
                      width="20"
                      height="20"
                      color="#F0554E"
                    />

                  </button>
                </div>
              </div>
              <div class="fullWidthButton">
                <button
                  type="button"
                  @click="form.ports.push({ interface: '', usage: '', id: form.ports.length + 1 })"
                >
                  <feather-icon
                    icon="PlusIcon"
                    width="20"
                    height="20"
                    color="#F0554E"
                  />
                  Add another port
                </button>
              </div>
            </div>
            <div
              v-if="form.type === 'switch' || (form.type ? form.type.includes('controller') : false)"
              class="section-block mb-4"
            >
              <div class="section-block__title">
                <feather-icon
                  icon="GlobeIcon"
                  width="24"
                  height="24"
                />
                <h2>Ports Layout</h2>
              </div>
              <ports-view
                :ports-layout="portsLayout"
                :set-ports-layout="setPortsLayout"
                :all-ports="form.ports"
                :columns="columns"
                :rows="rows"
                :set-grid-size="setGridSize"
                :update-on-create="true"
                :on-hover-blur-port="onHoverBlurPort"
              />
              <div class="port-preview-container">
                <div
                  class="port-preview model-page"
                  :class="{ 'hovered': hoveredPort }"
                >
                  <p v-if="hoveredPort">
                    {{ hoveredPort.interface }}
                  </p>
                </div>
              </div>
            </div>

          </b-col>
          <!-- submit button -->
          <b-col
            cols="12"
            class="text-right buttons-container__left"
          >

            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="button"
              ok-variant="secondary"
              @click.prevent="goBack"
            >
              Cancel
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              @click.prevent="validationForm"
            >
              Submit
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BButton, BCard,
  BFormCheckbox,
} from 'bootstrap-vue'
import { required, max } from '@validations'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import { mapActions, mapState } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import PortsView from '../PortsView.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    vSelect,
    BFormCheckbox,
    PortsView,
  },
  data() {
    return {
      form: {
        name: '',
        type: null,
        manufacturer_id: null,
        sku: null,
        manufacturer_name: null,
        system_board_model: null,
        is_use_ip_firewall: false,
        is_only_new_capsman: false,
        ports: [
          {
            interface: '',
            usage: '',
            label: '',
            id: 1,
          },
        ],
      },
      hoveredPort: null,

      columns: 0,
      rows: 0,

      portsLayout: [],

      portsTypes: [
        'WAN',
        'LAN',
      ],

      required,
      max,
    }
  },
  computed: {
    ...mapState('hardwareModels', [
      'item',
    ]),
    ...mapFields('hardwareManufacturers', [
      'manufacturersList',
    ]),
    ...mapFields('hardwareModels', [
      'typesList',
    ]),
  },
  created() {
    this.getTypes()
    this.getManufacturersList()
  },
  mounted() {
    const { id } = this.$route.params

    if (id) {
      this.fetchModel(id)
    } else {
      this.$router.push({ name: 'error-404' })
    }
  },
  methods: {
    ...mapActions('hardwareModels', [
      'getItem',
      'updateItem',
      'getTypes',
    ]),
    ...mapActions('hardwareManufacturers', [
      'getManufacturersList',
    ]),
    /**
     * @params {number} id
     */
    onHoverBlurPort(port, isHover) {
      this.hoveredPort = isHover ? port : null
    },
    async fetchModel(id) {
      try {
        await this.getItem(id)
        this.form.type = this.item.type.id
        this.form.manufacturer_id = this.item.manufacturer.id
        this.form.name = this.item.name
        this.form.is_use_ip_firewall = this.item.is_use_ip_firewall
        this.form.sku = this.item.sku
        this.form.ports = this.item.ports ? this.item.ports.map((port, index) => ({ ...port, id: index + 1 })) : [
          {
            interface: '',
            usage: '',
            label: '',
            id: 1,
          },
        ]
        this.form.manufacturer_name = this.item.manufacturer_name
        this.form.system_board_model = this.item.system_board_model
        this.form.is_use_ip_firewall = !!this.item.is_use_ip_firewall
        this.form.is_only_new_capsman = !!this.item.is_only_new_capsman

        if (this.item.ports_slots) {
          this.parseGrid(this.item.ports_slots)
          this.setFormDisplayName(this.form.ports)
        }
      } catch (error) {
        const { status } = error.response
        if (status === 404) {
          this.$router.push({ name: 'error-404' })
        }
        if (!status) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Server error',
              icon: 'BellIcon',
              variant: 'danger',
            },
          })
        }
      }
    },
    setFormDisplayName(ports) {
      const newPorts = [...ports].map(port => {
        let portFromLayout
        this.portsLayout.forEach(row => {
          row.forEach(column => {
            if (column.port && column.port.interface === port.interface) {
              portFromLayout = column
            }
          })
        })

        if (portFromLayout) {
          return {
            ...port,
            label: portFromLayout.port ? portFromLayout.port.label : '',
          }
        }
        return {
          ...port,
          label: '',
        }
      })

      this.form = {
        ...this.form,
        ports: [...newPorts],
      }
    },
    setPortsLayout(newValue) {
      this.portsLayout = newValue
    },
    setGridSize(columns, rows) {
      this.columns = columns
      this.rows = rows
    },
    formGridData() {
      // make matrix array to the single array of objects
      const validatedSinglePorts = this.portsLayout.reduce((acc, row) => {
        row.forEach(column => {
          if (column.port) {
            acc.push({
              column: column.column,
              row: column.row,
              port: column.port,
              id: column.id || column.port.id,
            })
          }
        })
        return acc
      }, [])

      // for each find the port by id in the form.ports and reassign interface and usage and label
      const updateLayoutPorts = validatedSinglePorts.map(port => {
        const portFromInterfaces = this.form.ports.find(portProp => portProp.id === port.id)

        return {
          row: port.row,
          column: port.column,
          port: {
            interface: portFromInterfaces.interface,
            usage: portFromInterfaces.usage,
            label: portFromInterfaces.label,
          },
        }
      })

      return {
        slots: updateLayoutPorts,
        size: {
          columns: this.columns,
          rows: this.rows,
        },
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    parseGrid(payload) {
      const { slots, size } = payload
      // first create matrix with size of columns and rows
      const matrix = Array.from({ length: size.columns }, () => Array.from({ length: size.rows }, () => ({
        column: '',
        row: '',
        port: '',
      })))
      // fill it with slots row and column (slots: {row, column, port}[])
      slots.forEach(slot => {
        const { column, row } = slot
        const portFromInterfaces = this.form.ports.find(port => port.interface === slot.port.interface)
        matrix[column || 0][row || 0] = { ...slot, id: portFromInterfaces.id }
      })
      this.portsLayout = matrix

      this.columns = size.columns
      this.rows = size.rows
    },
    async validationForm() {
      const valid = await this.$refs.modelsUpdate.validate()

      if (this.form.type === 'switch' || this.form.type.includes('controller')) {
        if (this.columns === 0 || this.rows === 0) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Please fill the grid',
              icon: 'BellIcon',
              variant: 'danger',
            },
          })
          return
        }

        const ports = this.formGridData()

        if (ports.slots.length !== this.form.ports.length && this.form.type !== 'controller-combined') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Please fill the grid',
              icon: 'BellIcon',
              variant: 'danger',
            },
          })
          return
        }
      }

      if (valid) {
        try {
          const { id } = this.$route.params
          const ports = this.formGridData()

          const payload = {
            id,
            ...this.form,
          }

          if (this.form.type === 'switch' || this.form.type.includes('controller')) {
            payload.ports_slots = JSON.stringify(ports)
          }

          await this.updateItem(payload)

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Success!',
              icon: 'BellIcon',
              variant: 'success',
            },
          })

          this.$router.push({ name: 'hardware-models-list' })
        } catch (error) {
          const { status } = error.response

          if (!status) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Server error',
                icon: 'BellIcon',
                variant: 'danger',
              },
            })
          }

          if (status === 422) {
            const { fields } = error.response.data

            this.$refs.modelsUpdate.setErrors(fields)
          }
        }
      }
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

</style>
